import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MdsButtonComponent } from '@medpacesoftwaredevelopment/designsystem';
import { Caregiver } from '@models/patient';

@Component({
    selector: 'medpace-caregiver-info-element',
    imports: [MdsButtonComponent],
    templateUrl: './caregiver-info-element.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CaregiverInfoElementComponent {
    public readonly caregiver = input.required<Caregiver>();
    public readonly isPatientProfile = input.required<boolean>();

    public readonly caregiverRemovedEvent = output<Caregiver>();
    public readonly caregiverModalOpenedEvent = output<Caregiver>();
    public readonly caregiverSetPrimaryEvent = output<Caregiver>();

    public readonly caregiverName = computed(() =>
        [this.caregiver().firstName, this.caregiver().middleName, this.caregiver().lastName].filter((n) => n).join(' ')
    );
}
